
// checks basic globals to help determine which environment we are in
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNode = isNode;
exports.thisOrThat = thisOrThat;
exports.thisOrThrow = thisOrThrow;

function isNode() {
  return typeof require === "function" && typeof exports === "object" && typeof module === "object" && typeof window === "undefined";
}

/*
   Return the value of `tryThis` unless it's undefined, then return `that`
 */

function thisOrThat(tryThis, that) {
  return typeof tryThis !== 'undefined' ? tryThis : that;
}

/*
   Return the value of `tryThir` or throw an error (with provided message);
 */

function thisOrThrow(tryThis, orThrowMessage) {
  if (typeof tryThis !== 'undefined') {
    return tryThis;
  }
  throw new Error(orThrowMessage);
}
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/snoocore/build/src/utils.js
// module id = 94
// module chunks = 0